import * as React from "react";
import { jobStatusTone } from "../../../lib/jobStatus.utils";
import { StatusPill, StatusPillOutline, StatusPillStyle } from "../../StatusPill";
import { ChipSize } from "../../ui";

/** A job's status in its tone's colours. */
export const JobStatusPill: React.FC<{
  status?: string | null;
  variant?: StatusPillStyle;
  outline?: StatusPillOutline;
  size?: ChipSize;
  className?: string;
  /** Size or spacing for a particular place, applied over the defaults. */
  style?: React.CSSProperties;
}> = ({ status, ...rest }) => (
  <StatusPill
    label={status ?? "No status"}
    ariaLabel={`Job status: ${status ?? "none"}`}
    tone={jobStatusTone(status)}
    {...rest}
  />
);
